import get from './get'
import detail from './detail'

export default {
    get,
    detail,
}
